import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

function IndustryFilter({ IndustriesOptions, setIndustriesOptions, customPathname, label = "Industry", isPopupOpen, setIsPopupOpen }) {
    const { Industries, refineSearchFilters, accessControl } = useContext(PeFilterContext);
    
    // Use internal state only if props are not provided (for backward compatibility)
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.industry?.map(value => value.id) ?? [];
        setIndustriesOptions(Industries?.map(industry => ({ ...industry, isChecked: industryIds.includes(industry.id) })));
    }, [Industries, customPathname, refineSearchFilters, setIndustriesOptions]);

    const enabledIndustryIds = accessControl ? accessControl?.peindustries?.id || [] : [];
    const disabledIndustries = enabledIndustryIds?.length > 0 ? IndustriesOptions?.filter(op => !enabledIndustryIds?.includes(op.id)) : [];

    const handleIndustryChange = (e) => {
        const { id, checked, name, filteredIds } = e.target;
        
        // Handle Select All / Deselect All
        if (name === 'filteredSelect') {
            const updatedOptions = IndustriesOptions.map(industry =>
                filteredIds.includes(industry.id) ? { ...industry, isChecked: checked } : industry
            );
            setIndustriesOptions(updatedOptions);
        } else {
            // Handle individual checkbox
            const updatedOptions = IndustriesOptions.map(industry =>
                industry.id === parseInt(id) ? { ...industry, isChecked: checked } : industry
            );
            setIndustriesOptions(updatedOptions);
        }
    };

    const selectedIndustryLength = IndustriesOptions?.filter(option => option.isChecked)?.length ?? 0;

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. {IndustriesOptions.slice(11,13).map(item => item.name).join(', ')}</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedIndustryLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedIndustryLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-2">
                        <MultiSelectEntity
                            handleEntityChange={handleIndustryChange}
                            primaryEntity={IndustriesOptions}
                            disabled={disabledIndustries}
                        />
                    </div>
                </Popup>
            )}
        </div>
    );
}

export default IndustryFilter;